import React from 'react';

const Default = () => <div></div>

export default Default;